import request from '@/utils/request'

let LapplyApi = {
  /*获取列表*/
  index(data) {
    return request._get('/shop/plus.lapply.index/index', data);
  },
 /*删除数据*/
 del(data,cancel) {
  return request._post('/shop/plus.lapply.index/del', data,cancel);
},
// 新增数据
add(data,cancel) {
  return request._post('/shop/plus.lapply.index/add', data,cancel);
},
// 更新数据
edit(data,cancel) {
  return request._post('/shop/plus.lapply.index/edit', data,cancel);
},
// 生成应用
gen(data,cancel) {
  return request._post('/shop/plus.lapply.index/gen', data,cancel);
},
 /*获取设置*/
 getSetting(data) {
  return request._get('/shop/plus.lapply.index/setting', data);
},
/*保存设置*/
saveSetting(data) {
  return request._post('/shop/plus.lapply.index/setting', data);
},
}
export default LapplyApi;



// WEBPACK FOOTER //
// ./src/api/lapply.js